import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import cx from 'classnames';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import ToggleCTALinkButton from 'components/essentials/ToggleCTALinkButton';
import JBImage from 'components/essentials/JBImage';
import JBResponsiveImage from 'components/essentials/JBResponsiveImage';
import JBIFrameHolder from 'components/essentials/JBIFrameHolder';
import CtaButton from 'components/essentials/Cta/CtaButton';
import CtaLink from 'components/essentials/Cta/CtaLink';
import definition from './definition.yaml';

// Matches the previous CSS background render box. Keep these as `ar` on
// <source> elements — JBImage strips width/height for renderAsSource.
const MOBILE_BACKGROUND_AR = '798:358';
const DESKTOP_BACKGROUND_AR = '540:560';

// Text panel is 100vw on small screens (2x ≈ 2048) or 480-540px on desktop.
const TEXT_PANEL_SRCSET_WIDTHS = [360, 540, 720, 960, 1080, 1600, 2048];
const BannerTextSection = t0 => {
  const $ = _c(72);
  const {
    className,
    config,
    fullWidth: t1,
    variant
  } = t0;
  const fullWidth = t1 === undefined ? false : t1;
  const {
    textContent: t2,
    colors: t3,
    cta,
    ctaColors: t4,
    toggleInputType,
    isCarousel: t5
  } = config;
  let t6;
  if ($[0] !== t2) {
    t6 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const textContent = t6;
  let t7;
  if ($[2] !== t3) {
    t7 = t3 === undefined ? {} : t3;
    $[2] = t3;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const colors = t7;
  let t8;
  if ($[4] !== t4) {
    t8 = t4 === undefined ? {} : t4;
    $[4] = t4;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const ctaColors = t8;
  const isCarousel = t5 === undefined ? false : t5;
  const [iFrameVisibility, setIFrameVisibility] = useState(false);
  const {
    backgroundImage,
    icon,
    heroFancyText,
    heroFancyTextColor,
    heroLogomark,
    body,
    title,
    disclaimer,
    iconWidth: t9
  } = textContent;
  const iconWidth = t9 === undefined ? "50%" : t9;
  let t10;
  if ($[6] !== colors) {
    t10 = get(colors, "textHex", definition.props.colors.textHex);
    $[6] = colors;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const colorsTextHex = t10;
  let t11;
  if ($[8] !== ctaColors) {
    t11 = get(ctaColors, "backgroundHex", definition.props.ctaColors.backgroundHex);
    $[8] = ctaColors;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const ctaColorsBackgroundHex = t11;
  let t12;
  if ($[10] !== ctaColors) {
    t12 = get(ctaColors, "textHex", definition.props.ctaColors.textHex);
    $[10] = ctaColors;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const ctaColorsTextHex = t12;
  let t13;
  if ($[12] !== ctaColorsBackgroundHex) {
    t13 = {
      backgroundColor: ctaColorsBackgroundHex
    };
    $[12] = ctaColorsBackgroundHex;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== ctaColorsTextHex) {
    t14 = {
      color: ctaColorsTextHex
    };
    $[14] = ctaColorsTextHex;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== t13 || $[17] !== t14) {
    t15 = {
      background: t13,
      text: t14
    };
    $[16] = t13;
    $[17] = t14;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  const ctaStyles = t15;
  const isFullWidthPanel = fullWidth || variant === "ShopPagePromotionPanel";
  const backgroundSizes = isFullWidthPanel ? "100vw" : "(max-width: 1023px) 100vw, (max-width: 1439px) 480px, 540px";
  const t16 = `relative px-5 py-8 flex flex-none h-full w-full flex-col justify-center overflow-hidden md:px-[3.333vw] md:py-8 lg:[text-align:initial] lg:min-w-[480px] lg:px-[3.333vw] lg:py-0 lg:w-[480px] min-[1440px]:min-w-[540px] min-[1440px]:w-[540px] ${className}`;
  const t17 = variant === "ShopPagePromotionPanel";
  let t18;
  if ($[19] !== fullWidth || $[20] !== isCarousel || $[21] !== t16 || $[22] !== t17) {
    t18 = cx(t16, {
      "lg:min-w-full lg:w-full": fullWidth,
      "pl-[calc(3.333vw_+_20px)]": isCarousel,
      "!p-[55px] !w-full !min-w-full !rounded-[.5rem] md:max-[1023px]:!rounded-none": t17
    });
    $[19] = fullWidth;
    $[20] = isCarousel;
    $[21] = t16;
    $[22] = t17;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== backgroundImage || $[25] !== backgroundSizes || $[26] !== isFullWidthPanel) {
    t19 = backgroundImage && <div aria-hidden="true" className="absolute inset-0 z-0 [&_picture]:block [&_picture]:h-full [&_picture]:w-full"><JBResponsiveImage><JBImage alt="" ar={MOBILE_BACKGROUND_AR} auto="format,compress" crop="center" fit="crop" lazy={false} media="(max-width: 1023px)" renderAsSource={true} sizes="100vw" src={backgroundImage} srcSetOptions={{
          widths: TEXT_PANEL_SRCSET_WIDTHS
        }} /><JBImage alt="" ar={DESKTOP_BACKGROUND_AR} auto="format,compress" crop="center" fit="crop" lazy={false} media="(min-width: 1024px)" renderAsSource={true} sizes={isFullWidthPanel ? "100vw" : "(max-width: 1439px) 480px, 540px"} src={backgroundImage} srcSetOptions={{
          widths: TEXT_PANEL_SRCSET_WIDTHS
        }} /><JBImage alt="" ar={DESKTOP_BACKGROUND_AR} auto="format,compress" className="h-full w-full object-cover" crop="center" fit="crop" lazy={false} priority={true} sizes={backgroundSizes} src={backgroundImage} srcSetOptions={{
          widths: TEXT_PANEL_SRCSET_WIDTHS
        }} /></JBResponsiveImage></div>;
    $[24] = backgroundImage;
    $[25] = backgroundSizes;
    $[26] = isFullWidthPanel;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== icon || $[29] !== iconWidth) {
    t20 = icon && <img className="mb-5 w-1/2 max-w-[260px] md:max-w-[50%]" src={icon} alt="Icon" style={{
      width: iconWidth
    }} />;
    $[28] = icon;
    $[29] = iconWidth;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== heroLogomark) {
    t21 = heroLogomark && <JBImage className="mb-5" src={heroLogomark} width={400} height={200} />;
    $[31] = heroLogomark;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== heroFancyText || $[34] !== heroFancyTextColor) {
    t22 = heroFancyText && <span className="mb-5 text-[1.4rem] non-italic font-normal md:text-[1.4rem]" style={{
      color: heroFancyTextColor
    }}>{heroFancyText}</span>;
    $[33] = heroFancyText;
    $[34] = heroFancyTextColor;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== colorsTextHex) {
    t23 = {
      color: colorsTextHex
    };
    $[36] = colorsTextHex;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== t23 || $[39] !== title) {
    t24 = <h1 className="text-4xl font-bold mb-3 md:mb-5" style={t23}>{title}</h1>;
    $[38] = t23;
    $[39] = title;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] !== body || $[42] !== colorsTextHex) {
    t25 = body && <p className="text-base font-bold mb-6 md:text-lg md:font-bold" style={{
      color: colorsTextHex
    }}>{body}</p>;
    $[41] = body;
    $[42] = colorsTextHex;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== cta || $[45] !== ctaStyles) {
    t26 = !!cta && cta.content && (!cta.embedCode || !cta.embedCode.enabled) && <div><CtaLink style={ctaStyles} to={cta.linkTo} styling={cta.style} color="brand">{cta.content}</CtaLink></div>;
    $[44] = cta;
    $[45] = ctaStyles;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] !== ctaStyles || $[48] !== toggleInputType) {
    t27 = !!toggleInputType && <ToggleCTALinkButton style={ctaStyles} toggleInputType={toggleInputType} />;
    $[47] = ctaStyles;
    $[48] = toggleInputType;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== cta || $[51] !== ctaStyles || $[52] !== iFrameVisibility || $[53] !== toggleInputType) {
    t28 = !toggleInputType && !!cta && cta.embedCode && cta.embedCode.enabled && <div>{iFrameVisibility ? <JBIFrameHolder isOpen={iFrameVisibility} onClose={setIFrameVisibility} script={cta.embedCode.value || ""} /> : null}<CtaButton style={ctaStyles} onClick={() => {
        setIFrameVisibility(true);
      }} color={cta.color || "brand"} styling={cta.style || "solid-button"}>{cta.content}</CtaButton></div>;
    $[50] = cta;
    $[51] = ctaStyles;
    $[52] = iFrameVisibility;
    $[53] = toggleInputType;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== colorsTextHex || $[56] !== disclaimer) {
    t29 = disclaimer && <p className="mt-4 mb-0 opacity-75 md:mt-6 text-xs font-bold" style={{
      color: colorsTextHex
    }}>{disclaimer}</p>;
    $[55] = colorsTextHex;
    $[56] = disclaimer;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] !== t20 || $[59] !== t21 || $[60] !== t22 || $[61] !== t24 || $[62] !== t25 || $[63] !== t26 || $[64] !== t27 || $[65] !== t28 || $[66] !== t29) {
    t30 = <div className="relative z-10">{t20}{t21}{t22}{t24}{t25}{t26}{t27}{t28}{t29}</div>;
    $[58] = t20;
    $[59] = t21;
    $[60] = t22;
    $[61] = t24;
    $[62] = t25;
    $[63] = t26;
    $[64] = t27;
    $[65] = t28;
    $[66] = t29;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== t18 || $[69] !== t19 || $[70] !== t30) {
    t31 = <div className={t18}>{t19}{t30}</div>;
    $[68] = t18;
    $[69] = t19;
    $[70] = t30;
    $[71] = t31;
  } else {
    t31 = $[71];
  }
  return t31;
};
BannerTextSection.propTypes = {
  config: PropTypes.shape({
    colors: PropTypes.shape({
      textHex: PropTypes.string
    }),
    cta: PropTypes.shape({
      color: PropTypes.string,
      content: PropTypes.string,
      embedCode: PropTypes.shape({
        enabled: PropTypes.bool,
        value: PropTypes.string
      }),
      linkTo: PropTypes.string,
      style: PropTypes.string
    }),
    ctaColors: PropTypes.shape({
      backgroundHex: PropTypes.string,
      textHex: PropTypes.string
    }),
    isCarousel: PropTypes.bool,
    textContent: PropTypes.shape({
      backgroundImage: PropTypes.string,
      body: PropTypes.string,
      disclaimer: PropTypes.string,
      heroFancyText: PropTypes.string,
      heroFancyTextColor: PropTypes.string,
      icon: PropTypes.string,
      iconWidth: PropTypes.string,
      title: PropTypes.string
    }),
    toggleInputType: PropTypes.object
  }),
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  variant: PropTypes.oneOf(['ShopPagePromotionPanel'])
};
export default BannerTextSection;